import * as tslib_1 from "tslib";
import { Observable, of } from 'rxjs';
import { switchMap, withLatestFrom, map, catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { DomainService } from 'modules/core/services/domain.service';
import { Selectors, Actions as RootActions } from 'store/root-reducer';
import { DomainActionTypes, CreateDomainSuccess, CreateDomainFailure } from 'store/actions/domain.actions';
import { SnackbarService } from 'app/services/snackbar.service';
var DomainEffects = /** @class */ (function () {
    function DomainEffects(actions$, domainService, store, snackbar) {
        var _this = this;
        this.actions$ = actions$;
        this.domainService = domainService;
        this.store = store;
        this.snackbar = snackbar;
        this.LoadList = this.actions$.pipe(ofType(DomainActionTypes.LOAD_DOMAIN_LIST), map(function (action) { return action.payload; }), withLatestFrom(this.store.select(Selectors.auth.getUser)), switchMap(function (_a) {
            var payload = _a[0], user = _a[1];
            return _this.domainService.getDomains(user.sub, payload).pipe(map(function (response) {
                return new RootActions.domain.LoadListSuccess(response.results);
            }), catchError(function (error) {
                _this.snackbar.error(error.message);
                return of(new RootActions.domain.LoadListFailure(error.message));
            }));
        }));
        this.SetDomain = this.actions$.pipe(ofType(DomainActionTypes.SET_DOMAIN), switchMap(function (input) {
            return of(new RootActions.auth.GetUserRoles({ domainId: input.payload.id }));
        }));
        this.ChangeDomain = this.actions$.pipe(ofType(DomainActionTypes.CHANGE_DOMAIN), switchMap(function (input) {
            return of(new RootActions.auth.GetUserRoles({ domainId: input.payload.id }));
        }));
        // Maybe use later.
        // @Effect() LoadListSuccess: Observable<Action> = this.actions$.pipe(
        //   ofType<LoadListSuccess>(DomainActionTypes.LOAD_DOMAIN_LIST_SUCCESS),
        //   map((action: LoadListSuccess) => action.payload),
        //   withLatestFrom(this.store.select(Selectors.domain.getCurrentDomain)),
        //   map(([payload, domain]: [[Domain], Domain]) => {
        //     if (!domain) {
        //       return new RootActions.domain.SetDomain(payload);
        //     }
        //     return new RootActions.domain.SetDomain(domain);
        //   })
        // );
        this.CreateDomain = this.actions$.pipe(ofType(DomainActionTypes.CREATE_DOMAIN), switchMap(function (action) {
            return _this.domainService.createDomains(action.payload).pipe(switchMap(function (res) {
                _this.snackbar.success('Domain successfully created');
                return of(new CreateDomainSuccess(res));
            }), catchError(function (err) {
                _this.snackbar.error('Domain creation failed');
                return of(new CreateDomainFailure(err));
            }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], DomainEffects.prototype, "LoadList", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], DomainEffects.prototype, "SetDomain", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], DomainEffects.prototype, "ChangeDomain", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], DomainEffects.prototype, "CreateDomain", void 0);
    return DomainEffects;
}());
export { DomainEffects };
